import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const OrderPackage = ApplicationRecord.extend({
  static: {
    jsonapiType: 'order_packages',
  },
  attrs: {
    url: attr(),
    pose: attr(),
    grad: attr(),
    price: attr(),
    scanned: attr(),
    quantity: attr(),
    emailPicture: attr(),
    isPreviewHidden: attr(),
    appointmentTime: attr(),
    schoolId: attr(),
    emailSent: attr({ persist: false }),
    createdAt: attr({ persist: false }),
    updatedAt: attr({ persist: false }),
    extraPoses: attr(),
    cartId: attr(),
    studentId: attr(),
    optionId: attr(),
    packageId: attr(),
    backgroundId: attr(),
    studentImageId: attr(),
    seniorImageId: attr(),
    poseId: attr(),
    downloadImageId: attr(),
    shipperInitials: attr(),
    shipDate: attr(),
    shipDestination: attr(),
    cart: belongsTo(),
    hasNameOnCover: attr(),
    apiOption: belongsTo(),
    options: hasMany(),
    package: belongsTo(),
    seniorImage: belongsTo(),
    student: belongsTo(),
    studentImage: belongsTo(),
    background: belongsTo(),
    extras: hasMany(),
    sheets: hasMany(),
    addonSheets: hasMany(),
    hasDownloadableImages: attr(),
    backgroundWasResubmitted: attr(),
    onHold: attr(),
    onHoldReason: attr(),
    orderPackageExtras: hasMany(),
    hasDigitalYearbook: attr(),
    appointmentSeason: attr(),
  },
  methods: {
    option: function() {
      if (this.optionId) return this.apiOption;

      return this.options && this.options[0];
    },
    total() {
      return this.price + this.extras.reduce((acc, extra) => acc + extra.price(), 0)
    },
  },
})

export default OrderPackage
